import React from "react";
import styles from "../Demographics.module.css";

//data source : https://censusreporter.org/profiles/16000US1714000-chicago-il/
const Sex = ({ data }) => {
  const chicago_sex = {
    M: {
      name: "Male",
      pop_pct: 49,
      homicide_count: 0,
    },
    F: {
      name: "Female",
      pop_pct: 51,
      homicide_count: 0,
    },
  };

  for (let i = 0; i < data.length; i++) {
    if (chicago_sex[data[i].gender]) {
      ++chicago_sex[data[i].gender].homicide_count;
    }
  }

  function formatNum(x) {
    return Number.parseFloat(x).toFixed(1);
  }
  return (
    <table>
      <thead>
        <tr>
          <th>Sex</th>
          <th>Total Homicides</th>
          <th>Pct. of homicides</th>
          <th>Pct. of population</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(chicago_sex)
          .sort((a, b) =>
            chicago_sex[a].homicide_count / data.length <
            chicago_sex[b].homicide_count / data.length
              ? 1
              : -1
          )
          .map((d) => {
            let homicideHighlight;
            let demographicHighlight;
            (chicago_sex[d].homicide_count / data.length) * 100 >
            chicago_sex[d].pop_pct
              ? (homicideHighlight = styles.Highlight)
              : (demographicHighlight = styles.Highlight);
            return (
              <tr key={chicago_sex[d].name}>
                <td>{chicago_sex[d].name}</td>
                <td>{chicago_sex[d].homicide_count}</td>
                <td className={[homicideHighlight, styles.Num].join(" ")}>
                  {formatNum(
                    (chicago_sex[d].homicide_count / data.length) * 100
                  )}
                  %
                </td>
                <td className={[demographicHighlight, styles.Num].join(" ")}>
                  {chicago_sex[d].pop_pct
                    ? chicago_sex[d].pop_pct + "%"
                    : "N/A"}
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export default Sex;
